import React from "react";
import { Link } from "react-router-dom";
import { FundraiserProgress } from "./FundraiserProgress";
import { DonateButton } from "./DonateButton";

export function ParticipantCard({ participant, fundraiserSlug, fundraiserTitle }) {
  const firstName = participant.name.split(" ")[0];

  return (
    <div className="flex flex-col bg-white rounded-2xl shadow-md hover:shadow-lg border border-orange-100 overflow-hidden transition-shadow duration-300">
      <div className="h-52 sm:h-56 shrink-0 overflow-hidden">
        <img
          src={participant.profileImage}
          alt={participant.name}
          className="w-full h-full object-cover"
        />
      </div>

      <div className="flex flex-col flex-1 p-5 sm:p-6 text-center">
        <p className="text-xs font-bold uppercase tracking-widest text-[#FF6600]">
          Support {firstName}'s Journey
        </p>
        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mt-1">
          Hi, I'm {firstName}!
        </h3>
        {participant.intro && (
          <p className="text-sm text-gray-600 mt-2 line-clamp-3">
            {participant.intro}
          </p>
        )}

        <div className="mt-4">
          <FundraiserProgress
            goal={participant.goal}
            raised={participant.raised}
            compact
          />
        </div>

        <div className="mt-auto pt-4 flex flex-col items-center gap-3">
          <Link
            to={`/fundraiser/${fundraiserSlug}/${participant.slug}`}
            className="inline-flex items-center text-orange-500 font-semibold text-sm group"
          >
            <span className="mr-1">View More</span>
            <svg
              className="w-4 h-4 transform transition-transform duration-300 group-hover:translate-x-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              />
            </svg>
          </Link>
          <DonateButton
            label="Donate Now"
            className="w-full justify-center px-6 py-2.5 text-sm"
            fundraiserId={fundraiserSlug}
            fundraiserTitle={fundraiserTitle}
            paymentFor="PARTICIPANT"
            participantId={participant.slug}
            participantName={participant.name}
          />
        </div>
      </div>
    </div>
  );
}
